export default {
  'af-ZA': 'Afrikaans',
  'ar-AE': 'Arabic',
  'ar-EG': 'Arabic',
  'ar-JO': 'Arabic',
  'ar-MA': 'Arabic',
  'ar-SA': 'Arabic',
  'de-DE': 'German',
  'en-GB': 'English',
  'en-US': 'English',
  'es-ES': 'Spanish',
  'es-MX': 'Spanish',
  'fr-CA': 'French',
  'fr-FR': 'French',
  'it-IT': 'Italian',
  'pt-BR': 'Portuguese',
  'ro-RO': 'Romanian',
  'ru-RU': 'Russian',
  'sw-KE': 'Swahili',
  'tr-TR': 'Turkish',
  'yo-NG': 'Yoruba',
};
